import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityOnIcon from '@material-ui/icons/Visibility';
import ToggleUseReceiptDialog from '../molecules/ToggleUseReceiptDialog';
import { getShopDetail } from '../../actions/Shop';
import { sendLogin } from '../../auth/Auth';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  },
  buttonToggleUseReceipt: {
    whiteSpace: 'nowrap'
  }
};

const enhance = compose(
  connect(
    state => ({
      budgets: state.budgets.list,
      totalCount: state.budgets.count,
      offset: 1
    }),
    dispatch => ({
      actions: bindActionCreators({ getShopDetail }, dispatch)
    })
  ),
  withState('openChange', 'updateOpenChange', false),
  withState('openChangeConfirm', 'updateOpenChangeConfirm', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  })
);

const button = enhance(
  ({
    classes,
    actions,
    checkSession,
    openChange,
    updateOpenChange,
    params,
    onChangeToggleUseReceipt,
    message,
    setMessage,
    openChangeConfirm,
    updateOpenChangeConfirm,
    setUseReceipt,
    useReceipt,
    progress,
    shopName,
    setShopName,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    shopNameError,
    setShopNameError,
    bankNameError,
    setBankNameError,
    bankBranchNameError,
    setBankBranchNameError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    hasDetail,
    setHasDetail,
    onCloseDialog
  }) => {
    const cancelAction = () => updateOpenChange(false);
    const changeAction = paramChange => {
      console.log('paramChange', paramChange);
      const paramSubmit = {
        connectSystemId: params.connectSystemId,
        useReceipt: parseInt(useReceipt || params.useReceipt || 0, 10),
        editInput: paramChange.editInput,
        ocrShopId: paramChange.ocrShopId
      };
      updateOpenChange(false);
      updateOpenChangeConfirm(false);
      onChangeToggleUseReceipt(paramSubmit);
    };
    const detailOpenAction = ocrShopId => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      actions.getShopDetail(ocrShopId).then(detailData => {
        checkSession(detailData);
        progress.updateOpenProgress(false);
        progress.updateLoading(false);
        progress.updateOpenProgress(false);
        progress.updateLoading(false);
        setShopName(detailData.payload.shopName);
        if (
          typeof detailData.payload.bankAccount !== 'undefined' &&
          detailData.payload.bankAccount !== null
        ) {
          setBankName(detailData.payload.bankAccount.bankName);
          setBankBranchName(detailData.payload.bankAccount.bankBranchName);
          setBankAccountType(detailData.payload.bankAccount.bankAccountType);
          setBankAccountTypeStr(
            detailData.payload.bankAccount.bankAccountTypeStr
          );
          setBankAccountNumber(
            detailData.payload.bankAccount.bankAccountNumber
          );
          setBankAccountHolder(
            detailData.payload.bankAccount.bankAccountHolder
          );
        }
      });
    };
    const openDialogToggleUseReceipt = () => {
      updateOpenChange(true);
      setUseReceipt(useReceipt || params.useReceipt);
      if (params.useReceipt === 1 && params.ocrShopId) {
        setHasDetail(true);
        detailOpenAction(params.ocrShopId);
      }
    };

    return (
      <div>
        <Button
          color="primary"
          onClick={() => openDialogToggleUseReceipt()}
          className={classes.buttonToggleUseReceipt}
        >
          {params.useReceipt ? (
            <>
              <VisibilityOnIcon className={classes.leftIcon} />
              利用する
            </>
          ) : (
            <>
              <VisibilityOffIcon className={classes.leftIcon} />
              利用しない
            </>
          )}
        </Button>
        <ToggleUseReceiptDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          cancelAction={cancelAction}
          changeAction={changeAction}
          target="Change"
          useReceipt={useReceipt}
          setUseReceipt={setUseReceipt}
          params={params}
          message={message}
          setMessage={setMessage}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          progress={progress}
          detailOpenAction={detailOpenAction}
          shopName={shopName}
          setShopName={setShopName}
          bankName={bankName}
          setBankName={setBankName}
          bankBranchName={bankBranchName}
          setBankBranchName={setBankBranchName}
          bankAccountType={bankAccountType}
          setBankAccountType={setBankAccountType}
          bankAccountTypeStr={bankAccountTypeStr}
          setBankAccountTypeStr={setBankAccountTypeStr}
          bankAccountNumber={bankAccountNumber}
          setBankAccountNumber={setBankAccountNumber}
          bankAccountHolder={bankAccountHolder}
          setBankAccountHolder={setBankAccountHolder}
          shopNameError={shopNameError}
          setShopNameError={setShopNameError}
          bankNameError={bankNameError}
          setBankNameError={setBankNameError}
          bankBranchNameError={bankBranchNameError}
          setBankBranchNameError={setBankBranchNameError}
          bankAccountNumberError={bankAccountNumberError}
          setBankAccountNumberError={setBankAccountNumberError}
          bankAccountHolderError={bankAccountHolderError}
          setBankAccountHolderError={setBankAccountHolderError}
          setHasDetail={setHasDetail}
          hasDetail={hasDetail}
          onCloseDialog={onCloseDialog}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
